import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {

  transform(records: Array<any>, args?: any): any {
    if (records !== null || records !== undefined) {
      return records.sort(function (a, b) {
        if (a[args.property] < b[args.property]) {
          return -1 * args.direction;
        } else if (a[args.property] > b[args.property]) {
          return 1 * args.direction;
        } else {
          return 0;
        }
      });
    } else {
      return 0;
    }
  };

}





// WEBPACK FOOTER //
// ./src/app/pipes/sort-by.pipe.ts